import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../styles/use-theme.js';
import { radius, typography, getVisibilityColors } from '../styles/theme.js';
import { PublicIcon, PrivateIcon } from './icons.js';
export function NoteVisibilityBadge({ visibility, isArchived = false, size = 'sm' }) {
    const { theme } = useTheme();
    const colors = getVisibilityColors(isArchived ? 'archived' : visibility);
    const iconSize = size === 'sm' ? 12 : 14;
    const fontSize = size === 'sm' ? typography.fontSize.xs : typography.fontSize.sm;
    const Icon = isArchived ? PrivateIcon : visibility === 'public' ? PublicIcon : PrivateIcon;
    return (_jsxs("span", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: size === 'sm' ? '2px 8px' : '4px 10px',
            borderRadius: radius.full,
            backgroundColor: colors.bg,
            color: colors.text,
            fontSize,
            fontWeight: typography.fontWeight.medium,
            lineHeight: 1.4,
        }, children: [_jsx("span", { style: { display: 'inline-flex' }, children: _jsx(Icon, {}) }), _jsx("span", { children: isArchived
                    ? '已归档'
                    : visibility === 'public' ? '公开' : '私有' })] }));
}
//# sourceMappingURL=note-visibility-badge.js.map